import { supabase } from '../lib/supabase';

export const authService = {
  async signUp(email, password, fullName, company = '') {
    try {
      const { data, error } = await supabase?.auth?.signUp({
        email,
        password,
        options: {
          data: {
            full_name: fullName,
            company: company,
            role: 'client'
          }
        }
      });
      if (error) {
        console.error('SignUp error:', error);
        throw error;
      }
      return data;
    } catch (error) {
      console.error('SignUp exception:', error);
      throw error;
    }
  },

  async signIn(email, password) {
    try {
      console.log('authService.signIn called for:', email);
      
      // First verify Supabase client is initialized
      if (!supabase) {
        throw new Error('Supabase client not initialized');
      }
      
      // Check if auth is available
      if (!supabase?.auth) {
        throw new Error('Supabase auth not available');
      }
      
      const { data, error } = await supabase?.auth?.signInWithPassword({ 
        email, 
        password 
      });
      
      if (error) {
        console.error('Supabase auth error:', error);
        console.error('Error code:', error?.code);
        console.error('Error message:', error?.message);
        console.error('Error status:', error?.status);
        
        // Provide more helpful error messages based on error type
        if (error?.message?.includes('Database error querying schema')) {
          throw new Error(
            'Authentication schema error. This is a Supabase configuration issue.\n\n' + 'To fix this, go to your Supabase Dashboard → SQL Editor and run:\n\n'+ 'ALTER ROLE authenticator SET search_path = "$user", public, auth;\n\n'+ 'Then restart your Supabase project under Settings → General → Restart project.'
          );
        }
        
        if (error?.message?.includes('Database error')) {
          throw new Error('Database connection error. Please check your Supabase configuration or try again later.');
        }
        
        if (error?.message?.includes('Invalid login credentials')) {
          throw new Error('Invalid email or password. Please check your credentials and try again.');
        }
        
        throw error;
      }
      
      console.log('Auth successful, user data:', data?.user?.id);
      return data;
    } catch (error) {
      console.error('SignIn exception:', error);
      throw error;
    }
  },

  async signOut() {
    try {
      const { error } = await supabase?.auth?.signOut();
      if (error) throw error;
    } catch (error) {
      console.error('SignOut error:', error);
      throw error;
    }
  },

  async getCurrentUser() {
    try {
      const { data: { user }, error } = await supabase?.auth?.getUser();
      if (error) throw error;
      return user;
    } catch (error) {
      console.error('GetCurrentUser error:', error);
      throw error;
    }
  },

  async getUserProfile(userId) {
    try {
      console.log('Fetching user profile for:', userId);
      const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.maybeSingle();
      if (error) {
        console.error('Error fetching user profile:', error);
        return null;
      }
      console.log('Profile data retrieved:', data);
      return data;
    } catch (error) {
      console.error('GetUserProfile exception:', error);
      return null;
    }
  },

  async updateUserProfile(userId, updates) {
    try {
      const { data, error } = await supabase?.from('user_profiles')?.update(updates)?.eq('id', userId)?.select()?.single();
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('UpdateUserProfile error:', error);
      throw error;
    }
  }
};